import { isStoreReady } from "./selectors";

function storesReady(...stores) {
  return stores.every(isStoreReady);
}

export { storesReady };
